module.exports = function getResource(label, vars = []) {
    let resources = {
        freeShippingMessage: `You’re only ${vars[0]} away from Free Shipping.`
    };

    return resources[label];
};
